<template>
  <section class="section">

    <b-breadcrumb :items="[
      { text: this.customerName, to: '/' },
      { text: 'Siti' }
    ]">
    </b-breadcrumb>

    <div class="d-flex justify-content-end mt-3 mb-2">
      <b-btn variant="primary" title="Svuota cache" class="mr-2" @click="emptyCache">Svuota cache</b-btn>
      <!-- <b-btn variant="primary" title="Esegui precalcolo" v-b-modal.precalcModal>Esegui precalcolo</b-btn> -->
    </div>

    <div class="row">
      <div class="col">

        <div class="card">
          <div class="card-block">
            <table class="table striped table-hover" v-if="sites.length">
              <thead>
                <tr>
                  <th></th>
                  <th>Sede</th>
                  <th>Referente</th>
                  <th>Telefono</th>
                  <th>Località</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="model.id" v-for="model in sites">
                  <td>
                    <router-link :to="'/sites/' + model.guid">
                      <font-awesome-icon icon="cogs" />
                    </router-link>
                  </td>
                  <td>{{ isDemo ? '#####' : model.name }}</td>
                  <td>{{ model.firstName }} {{ model.lastName }}</td>
                  <td>{{ model.phone }}</td>
                  <td>{{ model.addressTown }} ({{ model.addressState }})</td>
                  <td class="text-right">
                    <b-btn variant="success" v-b-tooltip.hover title="Ricalcola canali con formula"
                      @click="askPrecalculateSite(model.name, model.id)">
                      <font-awesome-icon icon="arrows-rotate" /> Ricalcola
                    </b-btn>
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-else>
              <div class="alert alert-warning" role="alert">Nessun sito associato al cliente.</div>
            </div>
          </div>
        </div>

        <b-btn variant="primary" to="/sites/new">
          <font-awesome-icon icon="plus" />
          Nuovo sito</b-btn>

        <b-btn variant="primary" v-b-tooltip.hover title="Scarica report" v-b-modal.modalReport>
          <font-awesome-icon icon="file-alt" /> Report
        </b-btn>
      </div>
    </div>

    <b-modal id="precalcModal" ref="precalcModal" title="Rettifica e precalcolo" centered header-bg-variant="warning"
      hide-footer>
      <h3>{{ clickedSiteName }}</h3>
      <form class="needs-validation" ref="form" novalidate @submit.prevent="precalculateData()">
        <b-row>
          <b-col>
            <div class="form-group">
              <label class="form-label">Da:</label>
              <vue-monthly-picker v-model="fromMonth" :monthLabels="monthLabels" :dateFormat="'MMMM/YYYY'"
                :clearOption="false" />
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label class="form-label">A:</label>
              <vue-monthly-picker v-model="toMonth" :monthLabels="monthLabels" :dateFormat="'MMMM/YYYY'"
                :clearOption="false" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex justify-content-end">
            <b-btn class="mr-2" variant="secondary" @click="$bvModal.hide('precalcModal')">Annulla</b-btn>
            <b-btn type="submit" variant="primary">Avvia precalcolo</b-btn>
          </b-col>
        </b-row>
      </form>
    </b-modal>

  </section>
</template>

<script>
import api from '@/services/api';
import { mapState, mapActions } from 'vuex';
import customerMenu from "../Menu.vue";
import VueMonthlyPicker from 'vue-monthly-picker';

var moment = require('moment');

export default {
  name: "CustomerSites",
  created() {
    this.reportData.month = moment().subtract(1, 'months').format('MM')
    this.reportData.year = moment().format('YYYY')
    if(this.user.sites && this.user.sites.length > 0) {
      this.reportData.site = this.user.sites[0].guid
    }
  },
  props: ['currentPage'],
  components: {
    customerMenu, VueMonthlyPicker
  },
  data() {
    return {
      current: {
        name: null, guid: null
      },
      reportData: {},
      fromMonth: moment().subtract(1, 'months').format(),
      toMonth: moment().format(),
      clickedSiteId: null,
      clickedSiteName: null,
    }
  },
  computed: {
    monthLabels() {
      return 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_')
    },
    sitesOptions() {
      return this.user.sites.map(s => { return { text: s.name, value: s.guid } })
    },
    months() {
      let options = []
      for(var i=1; i<=12; i++) {
        options.push({ text: moment(i+'', 'M').format('MMMM'), value: (i+'').padStart(2, '0') })
      }
      return options
    },
    years() {
      let options = []
      var currentYear = parseInt(moment().format('YYYY'))
      for(var i=currentYear; i>=currentYear - 5; i--) {
        options.push({ text: i, value: i })
      }
      return options
    },
    sites() {
      return this.user.sites
    },
    guid() {
      return this.$route.params.guid
    },
    user() {
      return this.$store.state.user
    },
    isSuperAdmin() {
      return this.user.level == 1
    },
    customerName() {
      return this.$store.state.user.altCustomerName ? this.$store.state.user.altCustomerName : this.$store.state.user.customerName
    },
    siteName() {
      return this.$store.state.user.altCustomerName ? '####' : this.form.name
    },
    isDemo() {
      return this.$store.state.user && this.$store.state.user.altCustomerName
    }
  },
  methods: {
    emptyCache() {
      this.$store.commit("loading");

      this.$store.dispatch('sites/emptyCache').then(data => {
        if(data.code == 1) {
          this.$notify({
            type: "success",
            text: "Cache svuotata",
            title: 'Successo'
          });
        } else {
          this.$notify({
            type: "error",
            text: data.message,
            title: 'Errore'
          });
        }

        this.$store.commit("stopLoading");
      })
    },
    async precalculateData() {
      if(! this.fromMonth || ! this.toMonth) {
        this.$notify({
          type: "error",
          text: "Inserire entrambe le date",
          title: 'Errore'
        });
        return;
      }
      if(moment(this.fromMonth, "MMMM-YYYY").isAfter(moment(this.toMonth, "MMMM-YYYY"))) {
        this.$notify({
          type: "error",
          text: "La data di inizio deve essere precedente a quella di fine",
          title: 'Errore'
        });
        return;
      }
      this.$store.commit("loading");

      const data = {};
      data.fromMonth = moment(this.fromMonth).format("MM-YYYY");
      data.toMonth = moment(this.toMonth).format("MM-YYYY");
      data.siteId = this.clickedSiteId

      this.$store.dispatch('sites/precalculate', data).then(() => {
        this.$notify({
          type: "success",
          text: "Operazione aggiunta alla coda",
          title: 'Successo'
        });
        this.$refs.precalcModal.hide();
        this.$store.commit("stopLoading");
      })
    },
    calculate(name, guid) {
      this.current.name = name
      this.current.guid = guid
      this.$refs.confirmFormulas.show()
    },
    empty(name, guid) {
      this.current.name = name
      this.current.guid = guid
      this.$refs.confirmEmptyFormulas.show()
    },
    goFormulas() {
      this.$store.commit("loading")
      this.$store.dispatch('sites/applyFormulas', this.current.guid).then(() => {
        this.$store.commit("stopLoading")
        // this.$toasted.show('Operazione completata', { duration: 3000, icon : 'check', theme: "bubble" })
        this.$notify({
          type: "success",
          text: "Operazione completata",
          title: 'Successo'
        });
      })
    },
    askPrecalculateSite(siteName, siteId) {
      this.clickedSiteId = siteId
      this.clickedSiteName = siteName
      this.$refs.precalcModal.show()
    },
    precalculateSite() {
      this.$store.commit("loading")
      this.$store.dispatch('sites/precalculate', {
        siteId: this.clickedSiteId,
        fromMonth: moment(this.fromMonth).format("MM-YYYY"),
        toMonth: moment(this.toMonth).format("MM-YYYY")
      }).then(() => {
        this.$store.commit("stopLoading")
        // this.$toasted.show('Operazione completata', { duration: 3000, icon : 'check', theme: "bubble" })
        this.$notify({
          type: "success",
          text: "Precalcolo aggiunto alla coda",
          title: 'Successo'
        });
      })
    },
    emptyFormulas() {
      this.$store.commit("loading")
      this.$store.dispatch('sites/emptyFormulas', this.current.guid).then(() => {
        this.$store.commit("stopLoading")
        // this.$toasted.show('Operazione completata', { duration: 3000, icon : 'check', theme: "bubble" })
        this.$notify({
          type: "success",
          text: "Operazione completata",
          title: 'Successo'
        });
      })
    },
    downloadReport() {
      this.$store.commit("loading")
      let guid = this.reportData.site
      let month = this.reportData.month + "-" + this.reportData.year

      this.$store.dispatch('sites/report', { guid, month }).then(data => {
        this.$store.commit("stopLoading")
        location.href = "/report/download/" + data
      })
      this.$bvModal.hide("modalReport")
    },

    previewReport() {
      this.$bvModal.hide("modalReport")
      let month = this.reportData.month + "-" + this.reportData.year
      this.$router.push({ path: `/report/${this.reportData.site}/${month}` })
    }
  }
}
</script>

<style scoped>
.status-inactive {
  color:red;
}
.status-active {
  color:green;
}
.status-active:hover {
  color:red;
}
.status-inactive:hover {
  color:green;
}
.status-inactive,
.status-active {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Sites/Sites.vue